import React from 'react'

import { appParams } from '@portal/client-info'

import { isPortalMaintenanceEnabled } from '@/shared/config'
import { localstorage } from '@/shared/lib/local-storage'

export const usePortalMaintenance = (): boolean => {
    const [isMaintenance, setIsMaintenance] = React.useState(false)

    // Delay the check for maintenance mode to avoid react hydration errors
    React.useEffect(() => {
        if ('skipPortalMaintenanceCheck' in appParams) {
            localstorage.setItem('PORTAL_MAINTENANCE_SKIP', 'true')
        }

        setIsMaintenance(isPortalMaintenanceEnabled())
    }, [])

    return isMaintenance
}
